// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_sv-0";